import React from 'react';

const URL_REGEX = /(https?:\/\/[^\s<>"{}|\\^`[\]]+)/g;

export function LinkifyText({ text, className = '' }) {
  if (!text) return null;
  
  const parts = text.split(URL_REGEX);
  
  return (
    <span className={className}>
      {parts.map((part, i) =>
        URL_REGEX.test(part) ? (
          <a
            key={i}
            href={part}
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary underline underline-offset-2 hover:text-primary/70 transition-colors break-all"
            onClick={(e) => e.stopPropagation()}
            data-testid={`linkified-url-${i}`}
          >
            {part}
          </a>
        ) : (
          <React.Fragment key={i}>{part}</React.Fragment>
        )
      )}
    </span>
  );
}
